import { defineStore, acceptHMRUpdate } from "pinia";
import { ref } from "vue";
import { PartnerCut } from "@/types/api/PartnerCut";
import client from "@/api/openapi-ts";

export const usePartnerCutStore = defineStore("partnerCut", () => {
  const loading = ref(false);
  const partnerCuts = ref<PartnerCut[]>([]);

  return {
    // ------------- GETTERS -------------
    loading,
    partnerCuts,

    // ------------- ACTIONS -------------
    async get(metaAudienceId: number) {
      loading.value = true;
      try {
        const { data, error } = await client.GET(
          "/api/v1/meta_audiences/{meta_audience_id}/partner_cuts",
          {
            params: { path: { meta_audience_id: metaAudienceId } },
          },
        );
        if (error) {
          throw error;
        }
        return (data as PartnerCut[]) ?? [];
      } finally {
        loading.value = false;
      }
    },
    async getListForMetaAudience(metaAudienceId: number) {
      loading.value = true;
      partnerCuts.value = [];
      try {
        const { data, error } = await client.GET(
          "/api/v1/meta_audiences/{meta_audience_id}/partner_cuts",
          {
            params: { path: { meta_audience_id: metaAudienceId } },
          },
        );
        if (error) {
          throw error;
        }
        partnerCuts.value = (data as PartnerCut[]) ?? [];
      } finally {
        loading.value = false;
      }
    },
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePartnerCutStore, import.meta.hot));
}
